module.exports = __webpack_public_path__ + "static/media/IMG_1272.JPG.652a0d06.jpg";